// Types
import type { Action } from "./types";

/**
 * @desc fetch whether automatic debits are stopped for a company
 * @param {*} data business guid
 * @return {*}  {Action}
 */
export const fetchCompanyEftPull = (data: any): Action => ({
  type: "FETCH_COMPANY_EFT_PULL",
  data,
});

/**
 * @param {*} data
 * @return {*}  {Action}
 */
export const editCompanyEftPull = (data: any): Action => ({
  type: "EDIT_COMPANY_EFT_PULL",
  data,
});

/**
 * @desc stop or resume automatic debits for a company
 * @param {*} data
 * @return {*}  {Action}
 */
export const updateCompanyEftPull = (data: any): Action => ({
  type: "UPDATE_COMPANY_EFT_PULL",
  data,
});

/**
 * @return {*}  {Action}
 */
export const clearCompanyEftPull = (): Action => ({
  type: "CLEAR_COMPANY_EFT_PULL",
});
